import initialState from "../initialState";
import * as types from "../../actions/actionTypes";

export default function rentMachineReducer(state = initialState.rentMachine, action) {
    switch (action.type) {
        case types.GET_MACHINE_RENT_SUCCESS:
            return  {
                id: action.rent.id,
                name: action.rent.name,
                description: action.rent.description,
                quantity: action.rent.quantity,
                price: action.rent.price,
                status: action.rent.status,
                image: action.rent.image,
                categoryId: action.rent.category.id
            };
        case types.RESET_MACHINE_RENT_SUCCESS:
            return {
                id: '',
                name: '',
                description: '',
                quantity: '',
                price: '',
                status: 1,
                image: ''
            };
        case types.CLEAR_MACHINE_RENT_IMAGE_SUCCESS:
            return {...state, image: ''};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/machine-rental/rentMachineReducer.js